export default {
  /**
   * Introduced when search started to have 2 types of url, a simplified (Google friendly) and your traditional query string.
   * Returns the url that represents the search the user wants to do.
   * @param state
   * @returns {string} the url that represents the search the user wants to do
   */
  getSearchUrl(state) {
    return state.searchUrl;
  },
  /**
   * Maps the store.query to an object used as the query params for an ajax request
   * @function
   * @param {object} vuex search module state.
   * @return {object} - ajax request parameters for backend
   */
  getQueryParamsRefined(state) {
    // const { show } = state.query;

    const paramsToKeep = Object.keys(state.query)
      .map((queryParam) => {
        let value = state.query[queryParam];

        if (Array.isArray(value)) {
          value = value.join(',');
        }

        return [queryParam, value];
      })
      .filter((queryParam) => (
        queryParam.length > 1
        && queryParam[1] !== undefined
        && queryParam[1] !== null
        && (queryParam[1].length || Number.isInteger(queryParam[1]))
      ))
      .map((queryParam) => {
        // obsolete
        // if (show === 'companies' && queryParam[0].indexOf('role') >= 0) {
        //   queryParam[0] = queryParam[0].replace('role', 'discipline');
        // }

        // RATE-4804
        // Lowercase the search term to make the urls more consistent.
        // This helps comparisions for saved searches
        if (queryParam[0] === 's') {
          console.log(queryParam);
          queryParam[1] = queryParam[1].toLowerCase();
        }

        return queryParam;
      })
      .reduce((accumlator, queryParam) => {
        accumlator[queryParam[0]] = queryParam[1]; // eslint-disable-line
        return accumlator;
      }, {});

    return paramsToKeep;
  },

  /**
   * Reformats the query_string object sent back via ajax so we can updated the browser url after ajax completes
   * @function
   * @param {object} routeParams - meta.query_string.array data sent back from ajax request
   * @return {object} - parsed params to add to the url
   */
  getFormattedRouteParams: () => ({ routeParams }) => {
    const routeParamsWithMultipleValues = [
      'programme',
      'top_employers', // why is it multiple?
      'discipline',
    ];

    Object.keys(routeParams).forEach((routeParamKey) => {
      if (!routeParamsWithMultipleValues.includes(routeParamKey)) return;

      routeParams[routeParamKey] = routeParams[routeParamKey].join(',');
    });

    return routeParams;
  },

  /**
   * Returns the default sort order for the current search type.
   * @function
   * @param {object} searchType - the value of the show param that dictates whethere the search is for companies|jobs|reviews
   * @return {string} - the default sort order for the current search type. e.g. jobs default sort is deadline closest.
   */
  getDefaultSortOrder: (state) => ({ searchType }) => {
    return state.defaultSortOrders[searchType];
  },
  /**
   * Introduced when search started to have 2 types of url, a simplified (Google friendly) and your traditional query string.
   * Works as a flag, defining when the state.query watcher is paused.
   *
   * @param state
   * @returns {boolean}
   */
  isQueryWatcherPaused(state) {
    return state.pauseQueryWatcher;
  },
  getDefaultUrls(state) {
    return state.defaultUrls;
  },
  getSortingUrls(state) {
    return state.sortingUrls;
  },
  getQueryParams(state) {
    return state.query;
  },
};
